<script>
import Vue from 'vue';
import {mapState, mapActions} from 'vuex';
import Loading from '../Loading/Loading.vue';
import Fake from '../Fake/Fake.vue';

export default Vue.extend({
    components: {
        Loading,
        Fake
    },
    computed: {
        ...mapState({
            downloadLoading: state => state.contract.contract.download.loading,
            history: state => state.contract.history.items,
            loading: state => state.contract.history.loading,
            error: state => state.contract.history.error,
            supplier: state => state.auth.supplier
        })
    },
    methods: {
        ...mapActions({
            downloadContract: 'contract/downloadContract'
        })
    }
});
</script>
<template>
    <div class="contract-list-overview">
        <div v-if="!loading" class="contract-list-overview__content">
            <div class="contract-list-overview__heading">
                <div class="contract-list-overview__header">
                    {{ $t('contractList.overview.heading.header') }}
                </div>
            </div>
            <div v-if="history"
                 class="contract-list-overview__list">
                <div v-for="item in history"
                     :key="item.contractId"
                     class="contract-list-overview__list-items">
                    <router-link v-if="item.status === 'readyForSupplier'"
                                 :to="{name: 'contract', params: {supplierId: supplier.id, contractId: item.contractId}}">
                        <div class="contract-list-overview__list-item">
                            <div class="contract-list-overview__list-item-year">{{ item.year }}</div>
                            <div class="contract-list-overview__list-item-status">
                                <span v-if="item.contractManagerNotes || item.supplierNotes"
                                      class="contract-list-overview__notes">
                                    <i class="fa fa-exclamation-triangle"/>
                                </span>
                                <span>{{ $t('contractList.overview.status.' + item.status) }}</span>
                            </div>
                        </div>
                    </router-link>
                    <div v-if="item.status !== 'readyForSupplier' && item.status !== 'completed'"
                         class="contract-list-overview__list-item--disabled">
                        <div class="contract-list-overview__list-item-year">{{ item.year }}</div>
                        <div class="contract-list-overview__list-item-status">
                            <span>{{ $t('contractList.overview.status.' + item.status) }}</span>
                        </div>
                    </div>
                    <div v-if="item.status === 'completed'"
                         class="contract-list-overview__list-item"
                         @click="downloadContract(item.contractS3)">
                        <div class="contract-list-overview__list-item-year">{{ item.year }}</div>
                        <div class="contract-list-overview__list-item-status">
                            <span>{{ $t('contractList.overview.download') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <fake v-if="loading"
              :header-rows="1"
              :header-cells="1"
              :body-rows="10"
              :body-cells="2"
              :key="'fake'"/>
        <div v-if="!error && !loading && !history"
             class="contract-list-overview__no-content">
            <i class="fa fa-bullhorn"/>
            <div class="contract-list-overview__no-content-message">{{ $t('contractList.overview.noContracts') }}</div>
        </div>
        <div v-if="error" class="contract-list-overview__error">
            <i class="fa fa-fw fa-exclamation-triangle"/>
            <div class="contract-list-overview__no-content-message">{{ $t('contractList.overview.error') }}</div>
        </div>
        <loading v-if="downloadLoading"/>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractListOverview/ContractListOverview.vue